function handles({ domain }) {
  return domain === 'streamable.com';
}

export default handles;



// WEBPACK FOOTER //
// ./src/components/StreamablePost/handles.js